import { Building2 } from "lucide-react";
import CrudPage from "@/components/CrudPage";
import CompanySummary from "@/components/CompanySummary";
import { StatusBadge } from "@/components/common";

const sections = [
  {
    title: "Company",
    fields: [
      { key: "name", label: "Company Name", required: true, span: 2, placeholder: "e.g. Euro Cars India" },
      { key: "status", label: "Status", type: "select", options: ["Active", "Inactive"] },
      { key: "contact_person", label: "Contact Person" },
      { key: "mobile", label: "Mobile", type: "tel" },
      { key: "email", label: "Email", type: "email" },
    ],
  },
  {
    title: "Billing & GST",
    fields: [
      { key: "gstin", label: "GSTIN", placeholder: "27ABCDE1234F1Z5" },
      { key: "state_code", label: "State Code", placeholder: "27" },
      { key: "billing_cycle", label: "Billing Cycle", type: "select", options: ["Monthly", "Fortnightly", "Weekly", "Per Duty"] },
      { key: "credit_days", label: "Credit Period (days)", type: "number" },
      { key: "billing_address", label: "Billing Address", type: "textarea", span: 3, rows: 2 },
    ],
  },
  {
    title: "Default Rates (auto-fill on duty)",
    fields: [
      { key: "default_package_rate", label: "Package Rate (₹)", type: "number" },
      { key: "extra_km_rate", label: "Extra KM Rate (₹)", type: "number" },
      { key: "extra_hr_rate", label: "Extra Hr Rate (₹)", type: "number" },
      { key: "rate_notes", label: "Rate Card / Notes", type: "textarea", span: 3, rows: 2 },
    ],
  },
];

const columns = [
  { label: "Company", render: (c) => <div><div className="font-semibold">{c.name}</div><div className="text-xs text-muted-foreground">{c.contact_person}</div></div> },
  { label: "Contact", render: (c) => <div className="text-xs">{c.mobile}<div className="text-muted-foreground">{c.email}</div></div> },
  { label: "GSTIN", render: (c) => <span className="font-mono text-xs">{c.gstin || "-"}</span> },
  { label: "Billing", render: (c) => <div className="text-xs">{c.billing_cycle || "-"}<div className="text-muted-foreground">{c.credit_days ? `${c.credit_days} days credit` : ""}</div></div> },
  { label: "Status", render: (c) => <StatusBadge value={c.status || "Active"} /> },
];

export default function Companies() {
  return (
    <div className="space-y-6">
    <CrudPage resource="companies" eyebrow="Masters" title="Companies" singular="Company" icon={Building2}
      subtitle="Corporate mobility clients — billing cycles, credit periods and GST details."
      sections={sections} columns={columns} defaults={{ status: "Active", billing_cycle: "Monthly", credit_days: 30, state_code: "27" }} />
    <CompanySummary />
    </div>
  );
}
